











import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import SelectLine from "../resources/selectLine.vue";
import SelectCurve from "../resources/selectCurve.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
    components: {
      SelectLine,
      SelectCurve
    }
})
export default class SelectLineBalloon extends Vue {
    select(type : string) {
        this.$emit("select", type);
        this.$emit("close");
    }

    close() {
        this.$emit("close");
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
